import { render, staticRenderFns } from "./SummaryContents-Other.vue?vue&type=template&id=d54dc81a&"
import script from "./SummaryContents-Other.vue?vue&type=script&lang=js&"
export * from "./SummaryContents-Other.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports